import React, { useState } from "react";
import packageJson from "../../../package.json"


// @components
import {
  Card,
  Input,
  Button,
  CardBody,
  Typography,
} from "@material-tailwind/react";
import imageLogo from "../../assets/logo_ticket_win.png";
import "./index.css"
import { GoogleAuthProvider, signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { authFB } from "../../firebase";
import { Notyf } from "notyf"; // Importa Notyf
import 'notyf/notyf.min.css'; 

const notyf = new Notyf();

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(authFB, email, password);
      notyf.success('Credenciales validas');
      
      setTimeout(() => {
        window.location.href = "/raffles";
      }, 2000);
      // Redirigir o manejar el estado después del inicio de sesión
    } catch (error) {
      console.error("Error signing in with email and password:", error);
      notyf.error("Error al iniciar sesión: " + error.message); // Muestra el mensaje de error
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(authFB, provider);
      // Redirigir o manejar el estado después del inicio de sesión
    } catch (error) {
      console.error("Error signing in with Google:", error);
      notyf.error("Error al iniciar sesión con Google: " + error.message); // Muestra el mensaje de error
    }
  };


  return (
    <section>
    <div className="mx-auto h-screen grid place-items-center bg-colors-container">
      <Card shadow={false} className="py-8 border border-gray-300">
      <div  className="flex justify-center align-center flex-col px-6 text-center">
            
            <div className="flex justify-center">
                <img src={imageLogo} alt="TicketWin APP" width={"250px"} />
            </div>

            <Typography
              variant="h1"
              color="blue-gray"
              className="mt-4 mb-2 !text-2xl lg:text-4xl"
            >
              TicketWin App 
              
            </Typography>
            <Typography className="!text-gray-600 text-[16px] font-normal md:max-w-lg">
                Organiza y participa en rifas de forma fácil y rápida. ¡Crea sorteos o adquiere tus tickets en segundos!            </Typography>
          </div>

        <CardBody>
          <form action="#" className="flex flex-col gap-4" onSubmit={handleEmailSignIn}>
            <div className="w-full">
              <label htmlFor="email">
                <Typography variant="small" color="blue-gray" className="block font-medium mb-2">
                  Tu correo
                </Typography>
              </label>
              <Input
                id="email"
                color="gray"
                size="lg"
                type="email"
                name="email"
                placeholder="name@mail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full placeholder:opacity-100 focus:border-t-primary border-t-blue-gray-200"
                labelProps={{ className: "hidden" }}
              />
            </div>
            <div className="w-full">
              <label htmlFor="password">
                <Typography variant="small" color="blue-gray" className="block font-medium mb-2">
                  Contraseña
                </Typography>
              </label>
              <Input
                id="password"
                color="gray"
                size="lg"
                type="password"
                name="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full placeholder:opacity-100 focus:border-t-primary border-t-blue-gray-200"
                labelProps={{ className: "hidden" }}
              />
            </div>
            <Button type="submit" size="lg" color="gray" fullWidth>
              Iniciar sesión
            </Button>
            {/* <Button
              variant="outlined"
              size="lg"
              className="flex h-12 border-blue-gray-200 items-center justify-center gap-2"
              fullWidth
              onClick={handleGoogleSignIn}
            >
              <img
                src={`https://www.material-tailwind.com/logos/logo-google.png`}
                alt="google"
                className="h-6 w-6"
              />
              Sign in with Google
            </Button> */}
            <Typography
                variant="small"
                className="text-center mx-auto max-w-[19rem] !font-medium !text-gray-600"
              >
                ¿No tienes cuenta?{" "}
                <a href="/signup" className="text-gray-900">
                  Crear cuenta ahora
                </a>{" "}
              </Typography> 
              <small>v{packageJson.version}</small>
          </form>
        </CardBody>
      </Card>
    </div>
  </section>
  );
}

export default Login;